import { NgClass } from '@angular/common';
import { Component, input, model, output, linkedSignal } from '@angular/core';
import { FormValueControl } from '@angular/forms/signals';
import { DebounceDirective } from '../../directives/debounce.directive';

@Component({
  selector: 'ui-textarea',
  imports: [NgClass, DebounceDirective],
  templateUrl: './textarea.html',
})
export class Textarea implements FormValueControl<string | null> {
  inputId = input<string | null>(null);
  placeholder = input<string>('');
  autocomplete = input<string>('off');
  rows = input<string>('4');

  fieldValueChange = output<string>();

  readonly value = model<string | null>(null);
  readonly disabled = input<boolean>(false);
  readonly touched = model<boolean>(false);
  readonly debounceMs = input<number | null>(null);

  protected displayValue = linkedSignal(() => this.value());

  protected updateModel(value: string) {
    this.value.set(value);
    this.fieldValueChange.emit(value);
  }
}
